export class SortLoopItem {
    key = '';
    title = '';
    order: number | undefined = -1;

    deserialize(data: any): this {
        this.key = data.key ?? '';
        this.title = data.title ?? '';
        this.order = data.order ?? undefined;
        return this;
    }

    serialize() {
        return {
            key: this.key,
            order: this.order,
        };
    }

    static Sort(i1: SortLoopItem, i2: SortLoopItem): number {
        return (i1.order ?? Number.MAX_SAFE_INTEGER) - (i2.order ?? Number.MAX_SAFE_INTEGER);
    }
}

export class SortLoop {
    loopname = '';
    items = [] as SortLoopItem[];

    deserialize(data: any): this {
        this.loopname = data.loopname ?? '';
        this.items = (data.items ?? []).map((item: any) => new SortLoopItem().deserialize(item));
        return this;
    }

    serialize() {
        return {
            loopname: this.loopname,
            items: this.items.map((item) => item.serialize()),
        };
    }
}
